import * as types from "./types";

export const actions = (dispatch) => ({
  updateMain: (data) => {
    dispatch({
      type: types.UPDATE_MAIN,
      data: data,
    });
  },

  updateMainUsers: (users) => {
    dispatch({
      type: types.MAIN_UPDATE_USERS,
      users: users,
    });
  },

  updateCredentials: (credentials) => {
    dispatch({
      type: types.MAIN_UPDATE_CREDENTIALS,
      credentials: credentials,
    });
  },

  updateWhatsappStatus: (whatsappOn) => {
    dispatch({
      type: types.MAIN_UPDATE_WHATSAPP_STATUS,
      whatsappOn: whatsappOn,
    });
  },

  addContactFromList: (contact) => {
    dispatch({
      type: types.ADD_CONTACT_FROM_LIST,
      contact: contact,
    });
  },

  removeContactFromList: (contact) => {
    dispatch({
      type: types.REMOVE_CONTACT_FROM_LIST,
      contact: contact,
    });
  },

  updateContactFromList: (contact) => {
    dispatch({
      type: types.UPDATE_CONTACT_FROM_LIST,
      contact: contact,
    });
  },

  updateContacts: (contacts) => {
    dispatch({
      type: types.UPDATE_CONTACT_LIST,
      contacts: contacts,
    });
  },

  overwriteTotals: (totals) => {
    dispatch({
      type: types.OVERWRITE_TOTALS,
      totals: totals,
    });
  },

  overwriteSearchContacts: (list) => {
    dispatch({
      type: types.OVERWRITE_SEARCH_CONTACTS,
      searchContacts: list,
    });
  },

  addFilterContactFromList: (contact) => {
    dispatch({
      type: types.ADD_FILTER_CONTACT,
      contact: contact,
    });
  },

  removeFilterContactFromList: (contact) => {
    dispatch({
      type: types.REMOVE_FILTER_CONTACT,
      contact: contact,
    });
  },

  updateFilterContactFromList: (contact) => {
    dispatch({
      type: types.UPDATE_FILTER_CONTACT,
      contact: contact,
    });
  },

  updateFilterContacts: (contacts) => {
    dispatch({
      type: types.UPDATE_FILTER_CONTACT_LIST,
      contacts: contacts,
    });
  },

  setFilterUsers: (userIds) => {
    dispatch({
      type: types.SET_FILTER_USERS,
      filterUsers: userIds,
    });
  },

  setFilterTags: (tags) => {
    dispatch({
      type: types.SET_FILTER_TAGS,
      filterTags: tags,
    });
  },

  setFilterTeams: (teams) => {
    dispatch({
      type: types.SET_FILTER_TEAMS,
      filterTeams: teams,
    });
  },

  setFilterScope: (scope) => {
    dispatch({
      type: types.SET_FILTER_SCOPE,
      filterScope: scope,
    });
  },

  clearAllFilters: () => {
    dispatch({
      type: types.CLEAR_ALL_FILTERS,
    });
  },

  contactsLoading: (isContactsLoading) => {
    dispatch({
      type: types.CONTACTS_LOADING,
      isContactsLoading: isContactsLoading,
    });
  },
});
